import React from "react";

import Slider from "react-slick";

const Testimonials = () => {
  const reviews = [
    {
      name: "Azure Fundamentals",
      position: "Microsoft",
      src: "images/az.png",
      desc: "",
      href: "https://www.credly.com/badges/25409e8c-6072-4ac8-b1a7-b64bae457d50",
    },
    {
      name: "Google Cloud Computing Foundations",
      position: "Google Cloud Computing Foundations ACADEMY",
      src: "images/certificado-Google.jpg",
      desc: "",
      href: "https://www.cloudskillsboost.google/public_profiles/54e816a0-184d-46c4-8261-b0b72fd19e52",
    },
    {
      name: "Web Developer - Oracle Cloud",
      position: "ONE – Oracle Next Education",
      src: "images/certificado-ONE.jpg",
      desc: "",
      href: "https://app.aluracursos.com/user/xochitl-rubi-97",
    },
    {
      name: "Java Full Stack",
      position: "Generation México",
      src: "images/certificado-Generation.jpg",
      desc: "",
      href: "images/certificado-Generation.jpg",
    },
  ];

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
  };

  return (
    <section id="testimonial" className="section bg-secondary">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeIn">
          <span className="bg-primary text-blanco px-2">Certificates</span>
        </p>
        <h2 className="text-10 fw-600 text-dark text-center wow fadeIn">
          My additional education
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-9 mx-auto wow fadeInUp">
            <Slider {...settings}>
              {reviews.length > 0 &&
                reviews.map((review, index) => (
                  <div  className="item text-center px-5" key={index}>
                    {" "}
                    <span className="text-9 text-primary">
                      <i className="fa fa-quote-start" />
                    </span>
                    <p className="text-5 text-dark">{review.desc}</p>
                    <a href={review.href}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                    <img 
                      className="img-fluid d-inline-block w-auto shadow img-certificados"
                      src={review.src}
                      alt={review.name}
                    />{" "}
                    </a>
                    <strong translate="no" className="d-block text-3 fw-600 text-dark">
                      {review.name}
                    </strong>{" "}
                    <span translate="no" className="text-dark">{review.position}</span>{" "}
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
